import React, { useState, useEffect } from 'react';
import classes from './ProductList.module.scss';
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Empty, Input, Grid } from 'antd';
import ProductBlock from './ProductBlock';
import { getProducts, getCategories } from '../../http/products';
import { useTranslation } from 'react-i18next';
import Button from '../UI/Button/Button';
import { SearchOutlined } from '@ant-design/icons';

const ProductList = ({ storageProducts, categories, activeCategory }) => {
  const [filter, setFilter] = useState('');
  const [products, setProducts] = useState(storageProducts);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const breakpoints = Grid.useBreakpoint();

  useEffect(() => {
    if (!categories.length)
      dispatch(getCategories());
  }, [])

  useEffect(() => {
    dispatch(getProducts(activeCategory?.id)).then((products) =>
      setProducts(
        filterProducts(products)
      )
    );
  }, [activeCategory]);

  const setActiveCategory = (category) => {
    dispatch({ type: 'Products/SET_ACTIVE_CATEGORY', payload: category });
  }

  const filterProducts = (items) =>
    items.filter((item) =>
      item.name.toLowerCase().includes(filter.toLowerCase())
    );

  const onSearch = () => {
    setProducts(
      filterProducts(storageProducts)
    );
  };

  const onCategoryClick = (category) => {
    setActiveCategory(category)
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ width: '100%', display: 'flex', gap: 10 }}>
          <Input
            placeholder={t('pages.main.marketplace.search')}
            size='large'
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            style={{
              width: '100%',
              borderRadius: 24,
              borderColor: 'black',
              padding: '10px 30px'
            }}
          />
          <Button onClick={onSearch} style={{ padding: breakpoints.xs ? '10px 15px' : '15px 30px'}}>
            {breakpoints.xs ? <SearchOutlined /> : t('pages.main.marketplace.search')}
          </Button>
        </div>
        <div className={classes.categories}>
          {categories.map((item) => (
            <div
              key={item.id}
              onClick={() => onCategoryClick(item)}
              className={`${classes.categories__item} ${activeCategory?.id === item.id ? classes.active : ''}`}
            >
              {i18n.language === 'en' ? item.name : item.name_lv}
            </div>
          ))}
        </div>
      </div>
      <h4 style={{ marginBottom: 40, marginTop: 60 }}>
        {t('pages.main.marketplace.subtitle')}
      </h4>
      {products?.length ? (
        <Row gutter={[20, 20]}>
          {products.map((item) => (
            <Col xs={24} sm={12} md={12} xl={6} xxl={6} key={item.id}>
              <ProductBlock {...item} id={item.t_product_id} />
            </Col>
          ))}
        </Row>
      ) : (
        <Empty
          description={t('etc.notFound')}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  storageProducts: state.games.products,
  categories: state.games.categories,
  activeCategory: state.games.activeCategory,
});

export default connect(mapStateToProps)(ProductList);
